import React, { useState, useEffect } from "react";
import { getPreviewCandidates } from "./shareImage";

// preview image that works for jpg/png and tiff - tries each candidate url until one loads
const ShareThumb = ({ row, imageCloudfront, width, className, alt = "Shared histology", fallback = null }) => {
    const candidates = getPreviewCandidates(row, imageCloudfront, width);
    const candidatesKey = candidates.join("|");
    const [index, setIndex] = useState(0);

    useEffect(() => { setIndex(0); }, [candidatesKey]);

    if (index >= candidates.length) return fallback;

    return (
        <img
            src={candidates[index]}
            alt={alt}
            className={className}
            onError={() => setIndex((i) => i + 1)}
        />
    );
};

export default ShareThumb;
